import {
  createAsyncThunk,
  createSlice,
} from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { DepartmentData } from '../model/response/department-data';
import { departmentApi } from '../administration/department-api';
import { Department } from '../model/department';

export interface DepartmentState {
  myDept: {
    data: any[] | Department[];
    status: 'idle' | 'loading' | 'ready';
  };
  all: {
    data: any[] | DepartmentData[];
    status: 'idle' | 'loading' | 'ready';
  };
}

const initialState: DepartmentState = {
  myDept: {
    data: [],
    status: 'idle',
  },
  all: {
    data: [],
    status: 'idle',
  },
};

export const getMyDepartment = createAsyncThunk(
  'dept/myself',
  async (arg: any, { getState }) => {
    const state = getState() as RootState;
    if (state.department.myDept.status === 'idle') {
      if (arg.deptId) {
        const res = await departmentApi.findAllSubDepartments(
          { deptId: arg.deptId, keyword: '' },
          {
            page: 0,
            size: 100,
            sort: 'asc',
            order: 'path',
          },
        );
        return res;
      } else return [];
    }
  },
);

export const getAllDepartment = createAsyncThunk(
  'dept/all',
  async (arg, { getState }) => {
    const state = getState() as RootState;
    if (state.department.all.status === 'idle') {
      const res = await departmentApi.getDepartments();
      return res;
    }
  },
);

export const deptSlice = createSlice({
  name: 'dept',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      getMyDepartment.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.myDept = {
            data: action.payload,
            status: 'ready',
          };
        }
      },
    );
    builder.addCase(
      getAllDepartment.fulfilled,
      (state, action: any) => {
        if (action.payload) {
          state.all = {
            data: action.payload,
            status: 'ready',
          };
        }
      },
    );
  },
});

export const selectDepartment = (state: RootState) =>
  state.department;

export default deptSlice.reducer;
